import { createContext, useContext, useState } from "react";
import { ALL_KEY } from "../../../components/CustomRadioButton/enumerations/enumerations";
import { CoachesContextProviderType, CoachesContextType } from "../data";

const CoachesContext = createContext<CoachesContextType>({
  value: ALL_KEY,
  setValue: (value: string) => {},
});

export const CoachesContextProvider = ({
  children,
}: CoachesContextProviderType) => {
  const [value, setValue] = useState(ALL_KEY);

  return (
    <CoachesContext.Provider value={{ value, setValue }}>
      {children}
    </CoachesContext.Provider>
  );
};

export const useCoachesContext = () => {
  const Value = useContext(CoachesContext);
  return Value;
};
